import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ICountry } from 'src/app/interface/country.interface';
import { IUserDetail, USER_TYPE } from 'src/app/interface/user.interface';
import { UserVerificationService } from 'src/app/services/user-verification/user-verification.service';

@Component({
  selector: 'app-user-verification-dialog',
  templateUrl: './user-verification-dialog.component.html',
  styleUrls: ['./user-verification-dialog.component.scss'],
})
export class UserVerificationDialogComponent {

  constructor (
    private userVerificationService: UserVerificationService,
  ) {}

  stage: 'form' | 'otp' | 'user_select' | 'ack' = 'form';
  errorMessage!: string;
  isLoading: boolean = false;
  formGroup: FormGroup = new FormGroup({
    full_name: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required])
  })
  userDetail!: IUserDetail;
  userList: IUserDetail[] = [];

  otpFormControl: FormControl = new FormControl();
  userTypeFormControl: FormControl = new FormControl();

  timerString: string = '00:60';
  timeIntervalRef: any;

  countries: ICountry[] = [
    { label: 'United States (+1)', value: 'US', flag: 'assets/images/us.png', dial_code: '+1' },
    { label: 'India (+91)', value: 'US', flag: 'assets/images/india-flag-icon.svg', dial_code: '+91' },
  ];
  selectedCountry: any = {
      phone: this.countries[0]
  };

  @Output() onVerification: EventEmitter<boolean> = new EventEmitter();

  onCountrySelect(country: ICountry, event: MouseEvent) {
    event.stopPropagation(); // This prevents the event from bubbling up
    this.selectedCountry.phone = country;
  }

  startTimer() {
    clearInterval(this.timeIntervalRef);

    let remainingTime = 60;
    this.timeIntervalRef = setInterval(() => {
      remainingTime--;

      // Format the time as MM:SS
      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime % 60;
      this.timerString = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

      // Stop when it reaches 00:00
      if (remainingTime <= 0) {
        clearInterval(this.timeIntervalRef);
      }
    }, 1000);
  }

  closeDialog (status: boolean) {
    this.onVerification.emit(status);

    // Reset
    this.stage = 'form';
    this.formGroup.reset();
  }

  send_otp () {
    this.errorMessage = '';
    this.isLoading = true;
    this.otpFormControl.reset();
    const { full_name, mobile } = this.formGroup.value;
    const countryCode = this.selectedCountry.phone.dial_code;

    this.userVerificationService.send_otp({ full_name, mobile: `${countryCode}${mobile}` }).subscribe({
      next: (res: any) => {
        this.startTimer();
        this.stage = 'otp';
      },
      error: (err) => {
        console.error("Send Otp", err);
        this.errorMessage = err?.error?.message || 'Failed to send OTP';
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  verify_otp () {
    this.errorMessage = '';
    this.isLoading = true;

    const { full_name, mobile } = this.formGroup.value;
    const countryCode = this.selectedCountry.phone.dial_code;

    this.userVerificationService.verify_otp({ full_name, mobile: `${countryCode}${mobile}`, otp: this.otpFormControl.value }).subscribe({
      next: (res: any) => {
        if(res?.data) {
          this._processUserList(res?.data);
          this.stage = 'user_select';
        } else {
          console.log("something went wrong res=", res);
          this.errorMessage = res?.message || 'Something went wrong, try again!';
        }
      },
      error: (err) => {
        console.error("Verify Otp", err);
        this.errorMessage = err?.error?.message || 'Failed to verify OTP';
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  selectUser () {
    this.userDetail = this.userTypeFormControl.value;
    this.userVerificationService.saveVerifiedUser(this.userDetail);
    this.stage = 'ack';
  }

  private _processUserList (users: IUserDetail[]) {
    const userOrder: any = {
      [USER_TYPE.Tenant]: {
        sort_order: 1,
        user_type_name: 'Tenant'
      },
      [USER_TYPE.Contractor]: {
        sort_order: 2,
        user_type_name: 'Contractor'
      },
      [USER_TYPE.SP]: {
        sort_order: 3,
        user_type_name: 'Service Provider'
      }
    }

    users.forEach((user) => {
      const order = userOrder[user?.user_type];

      user.sort_order = order.sort_order || 1;
      user.user_type_name = order.user_type_name || '';
    })



    this.userList = users?.sort((a, b) => Number(a.sort_order) - Number(b.sort_order));

  }
}
